import myData from "./states_india.json";
var statesData = myData;
    
    export default { statesData };